import './updated-at.component.scoped.scss'

const UpdatedAt = ({ children }: any) => {
  return <div className="updated-at">{children}</div>
}

export default UpdatedAt
